<template>
  <div>
    <v-card width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Contracts</h3>
        <v-spacer></v-spacer>

        <v-dialog persistent v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="modelPermissions.create"
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <contract-dialog
            v-if="dialog"
            :contracts="contracts"
            :client_id="client_id"
            :item="item"
            :close="close"
          ></contract-dialog>
        </v-dialog>
      </v-card-title>
      <v-dialog v-model="proofDialog">
        <proof-dialog
          v-if="proofDialog"
          :close="close"
          :contracts="contracts"
          :item="item"
        ></proof-dialog>
      </v-dialog>
      <picture-modal
        v-if="showImage"
        :showImage="showImage"
        @closeImg="showImage = false"
        :item="item"
      >
      </picture-modal>
      <v-data-table
        v-model="selectedContract"
        :server-items-length="contracts.total"
        :loading="loading"
        :headers="headers"
        :items="contracts.data"
        :options.sync="options"
        :items-per-page="10"
      >
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.report="{ item }">
          <v-btn text @click="proofReport(item)" color="secondary">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.show="{ item }">
          <v-btn text @click="showImageDialog(item)" color="secondary">
            <v-icon>mdi-file-image</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-btn color="primary" @click="_changeModel(1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" color="primary" @click="_changeModel(4)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import ContractDialog from './ContractDialog'
import { axios } from '../../../../utils'
import { mapGetters } from 'vuex'
import ProofDialog from '../../proof/ProofDialog.vue'
import PictureModal from './PictureModal.vue'

export default {
  name: 'ContractIndex',
  props: [
    'setContractId',
    'changeModel',
    'client_id',
    'showMessage',
    'contract_id'
  ],
  components: {
    ContractDialog,
    ProofDialog,
    PictureModal
  },
  data() {
    return {
      dialog: false,
      loading: false,
      proofDialog: false,
      showImage: false,
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Start Date',
          align: 'start',
          value: 'start_date'
        },
        {
          text: 'End Date',
          align: 'start',
          value: 'end_date'
        },
        {
          text: 'Sale Date',
          align: 'start',
          value: 'sale_date'
        },

        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false },
        {
          text: 'Ad Report',
          align: 'center',
          value: 'report',
          sortable: false
        },
        { text: 'View Report', align: 'center', value: 'show', sortable: false }
      ],

      contracts: [],
      options: {},
      item: {},
      search: '',
      selectedContract: []
    }
  },
  methods: {
    _changeModel(index) {
      this.changeModel(index)
    },
    showImageDialog(item) {
      this.item = item
      this.showImage = true
      console.log(this.item)
    },
    close() {
      this.item = {}
      this.dialog = false
      this.proofDialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getContracts() {
      this.loading = true
      console.log('getting contracts')
      axios
        .get(
          `api/admin/contracts?client_id=${this.client_id}&page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}`
        )
        .then(res => {
          this.contracts = res.data
          console.log(this.contracts)
          this.loading = false
          // console.log('done')
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.name}`)) {
        console.log('deleting contract with id ', item.id)
        axios
          .delete(`api/admin/contracts/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getContracts()
            }
          })
          .catch(err => console.log(err))
      }
    },
    proofReport(item) {
      // console.log('getting proof json response')
      // console.log(item.id)
      this.item = item
      this.proofDialog = true
    }
  },

  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('contract')
    }
  },

  watch: {
    options: {
      handler() {
        this.getContracts()
      },
      deep: true
    },
    search: {
      handler() {
        this.getContracts()
      },
      deep: true
    },
    client_id: {
      handler() {
        this.getContracts()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getContracts()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
